export default __webpack_public_path__ + "8018bbf74d25c9a525995dc3b14250b3.jpeg";